module.exports = __webpack_public_path__ + "dingbeauty-build/img/no-service.58278769.svg";